import React from 'react';

import ReactDOM from 'react-dom';

import { ReactComponent as CloseIcon } from '../../../../../assets/icons/v3/close.svg';
import { IBdsModal } from '../../../../interfaces/bdsModal';
import BdsButton from '../../Buttons/BdsButton/BdsButton';
import BdsIconButton from '../../Buttons/BdsIconButton/BdsIconButton';

import './BdsModal.scss';

const BdsModal = ({
  open,
  onClose,
  icon,
  title,
  description,
  footnote,
  primaryAction,
  secondaryAction,
  onBackdropClick,
  loading = false,
  reverseButtons = false,
  className = ''
}: IBdsModal) => {
  if (!open) {
    return null;
  }

  const handleBackdropClick = (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent> | React.MouseEvent<HTMLDivElement>
  ) => {
    if (e.target === e.currentTarget && onBackdropClick) {
      onBackdropClick(e);
    }
  };

  return ReactDOM.createPortal(
    <div className="bds-modal-backdrop" onClick={handleBackdropClick} data-experience="new">
      <div className={`bds-modal ${className}`}>
        <div className="bds-modal-container">
          {onClose && (
            <div className="bds-modal-close">
              <BdsIconButton
                icon={{ component: CloseIcon }}
                action={onClose}
                variant="transparent"
                size="sm"
                label="close-modal"
              />
            </div>
          )}
          <div className="bds-modal-icon">{icon}</div>
          <div className={`bds-modal-content ${primaryAction || secondaryAction ? 'actions-spacing' : ''}`}>
            <div className="bds-modal-dialog">
              <div className="bds-modal-title">{title}</div>
              <div className="bds-modal-description">{description}</div>
            </div>
            <div className={`bds-modal-actions ${reverseButtons ? 'flex-row-reverse' : ''}`}>
              {primaryAction && (
                <BdsButton
                  variant="primary"
                  size="l"
                  disabled={loading || primaryAction.disabled}
                  loading={loading}
                  action={primaryAction.onClick}
                  {...(primaryAction.loadingType && { loadingType: primaryAction.loadingType })}
                  {...(primaryAction.loadingText && { loadingText: primaryAction.loadingText })}
                  {...(primaryAction.iconRight && { iconRight: primaryAction.iconRight })}
                  {...(primaryAction.iconLeft && { iconLeft: primaryAction.iconLeft })}
                >
                  {primaryAction.label}
                </BdsButton>
              )}
              {secondaryAction && (
                <BdsButton
                  variant="secondary"
                  size="l"
                  disabled={loading}
                  loading={loading}
                  action={secondaryAction.onClick}
                  {...(secondaryAction.loadingType && { loadingType: secondaryAction.loadingType })}
                  {...(secondaryAction.loadingText && { loadingText: secondaryAction.loadingText })}
                  {...(secondaryAction.iconRight && { iconRight: secondaryAction.iconRight })}
                  {...(secondaryAction.iconLeft && { iconLeft: secondaryAction.iconLeft })}
                >
                  {secondaryAction.label}
                </BdsButton>
              )}
            </div>
          </div>
          {footnote && <div className="bds-modal-footnote">{footnote}</div>}
        </div>
      </div>
    </div>,
    document.body
  );
};

export default BdsModal;
